import {apiURL, StandardHeadersMode} from '@logistics-frontend/client-core/api/corp'
import {fetch} from '@logistics-frontend/client-core/utils/network'
import {createYaAuthMiddleware, fetchWithHeaders, withCSRF} from '@logistics-frontend/core/utils/network'
import * as t from '@logistics-frontend/modules/tariffs-v2/types'
import {get, pipe, raise} from '@logistics-frontend/utils'
import {addQuery} from '@logistics-frontend/utils/url'

import {config} from './config'

const SERVICE = 'cargo'
const API_BASENAME = config.config.basename ? `${config.config.basename}/api/taxi-corp` : 'api/taxi-corp'

const b2bFetch = pipe(
  fetchWithHeaders,
  createYaAuthMiddleware({
    host: config.config.b2bApiHost || raise('[tariffs] b2b-api-lk.go host not found'),
    headers: {},
  }),
  withCSRF,
)

const toTariffList = get('body.categories')
const toZoneList = get('zones')

function taxiCorpApiUrl(url: string) {
  return apiURL(url, {
    version: '1.0',
    type: API_BASENAME,
  })
}

function b2bApiUrl(url: string): string {
  return apiURL(url, {
    version: '1.0',
    type: 'corp-cabinet',
  })
}

export const fetchTariffList = ({zone, country}: t.TariffListRequestArgs): Promise<t.Category[]> =>
  b2bFetch({
    meta: {
      standardHeadersMode: StandardHeadersMode.Disable,
    },
    options: {
      credentials: 'include',
    },
    url: addQuery(b2bApiUrl('public-tariff'), {
      product: 'default',
      zone_name: zone,
      country,
      service: SERVICE,
    }),
  }).then(toTariffList)

export const fetchTariffZones = (): Promise<t.TariffZonesItem[]> =>
  fetch<never, t.GetTariffZonesResponse, t.GetTariffZonesResponse>({
    url: addQuery(taxiCorpApiUrl('public/tariff_zones'), {service: SERVICE}),
  }).then(toZoneList)
